// Do not append the string values of this enum as they're linked to database values
export enum MetricTypes {
  WEB = 'Web',
  INBOUND_CALL = 'InboundCall',
  CLICKS = 'Clicks',
  COST = 'Cost',
  REVENUES = 'Revenues', // Also known as "Sales"
  REVENUE_VALUES = 'RevenueValues',
  OPPORTUNITIES = 'Opportunities',
  OPPORTUNITY_VALUES = 'OpportunityValues',
  CPA = 'CPA',
  CPS = 'CPS',
  ROI = 'ROI',
  ROAS = 'ROAS',
  IMPRESSIONS = 'Impressions'
}
